export const calculateLevenshteinDistance = (s: any, t: any) => {
  if (!s.length) return t.length;
  if (!t.length) return s.length;
  const arr = [];
  for (let i = 0; i <= t.length; i++) {
    arr[i] = [i];
    for (let j = 1; j <= s.length; j++) {
      arr[i][j] =
        i === 0
          ? j
          : Math.min(
              arr[i - 1][j] + 1,
              arr[i][j - 1] + 1,
              arr[i - 1][j - 1] + (s[j - 1] === t[i - 1] ? 0 : 1)
            );
    }
  }
  return arr[t.length][s.length];
};

export const convertTurkishCharactersToEnglish = (text: string) => {
  return text
    .replaceAll("Ğ", "g")
    .replaceAll("Ü", "u")
    .replaceAll("Ş", "s")
    .replaceAll("I", "i")
    .replaceAll("İ", "i")
    .replaceAll("Ö", "o")
    .replaceAll("Ç", "c")
    .replaceAll("ğ", "g")
    .replaceAll("ü", "u")
    .replaceAll("ş", "s")
    .replaceAll("ı", "i")
    .replaceAll("ö", "o")
    .replaceAll("ç", "c");
};

export const convertToBase64 = (arrayBuffer: any) => {
  return new Promise((resolve, reject) => {
    const blob = new Blob([arrayBuffer], { type: "image/png" });
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data =
        typeof reader.result === "string" ? reader.result.split(",")[1] : null; // Remove "data:image/png;base64," part
      resolve(base64data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const base64ToFile = (
  base64String: string,
  fileName: string,
  mimeType: string
) => {
  // Decode the Base64 string
  const byteCharacters = atob(base64String);

  // Convert to byte array
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create Blob
  const blob = new Blob([byteArray], { type: mimeType });

  // Convert Blob to File
  return new File([blob], fileName, { type: mimeType });
};

export const mergeObjects = (...objects: any[]) => {
  const result: any = {};

  // Get all unique keys from all objects
  const allKeys = [...new Set(objects.flatMap((obj) => Object.keys(obj)))];

  // For each key, find the first non-null value
  allKeys.forEach((key) => {
    result[key] = objects.reduce((acc, obj) => {
      return acc !== null ? acc : obj[key] || null;
    }, null);
  });

  return result;
};
